import React from 'react'
import ReactDOM from 'react-dom'
import { browserHistory } from 'react-router'
import Home from './pages/Home'
import Container from './components/Container'
import './index.css'

ReactDOM.render(
  <Container><Home history={browserHistory} /></Container>,
  document.getElementById('root'),
)



// WEBPACK FOOTER //
// ./src/index.js